// Module
var code = "<div class=\"cell-editor-shell\" [ghGridCellTooltip]=\"message\" matTooltipPosition=\"below\" matTooltipClass=\"editable-cell-tooltip\"> <ng-content></ng-content> </div> ";
// Exports
module.exports = code;